export default __webpack_public_path__ + "static/Logo Placement – TSS – 1280px-f86b5713d9ff86469957577762926b3e.jpg";